/*
  Jhilma: Custom Size switch + Customisation Charges.
  Loaded on every page from layout/theme.liquid.
*/
(function () {
  var CHARGE_HANDLE = 'customisation-charges';
  var CUSTOM_KEYS = ['_custom dresses', 'Neckline', 'Sleevetype', 'Bottomlength', 'Pantlength'];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- 1. Size block ---------- */
  function save(k, v) { try { localStorage.setItem('jh_size_' + k, v); } catch (e) {} }
  function load(k) { try { return localStorage.getItem('jh_size_' + k); } catch (e) { return null; } }

  function setMode(block, mode) {
    block.querySelectorAll('[data-jh-panel]').forEach(function (panel) {
      var on = panel.getAttribute('data-jh-panel') === mode;
      panel.hidden = !on;
      panel.querySelectorAll('select, input').forEach(function (el) { el.disabled = !on; });
    });
  }

  function restore(sel) {
    if (sel.value) return;
    var v = load(sel.getAttribute('data-jh-remember'));
    if (v && [].some.call(sel.options, function (o) { return o.value === v && !o.disabled; })) sel.value = v;
  }

  function initBlocks() {
    document.querySelectorAll('[data-jh-size]').forEach(function (block) {
      var checked = block.querySelector('[data-jh-mode]:checked');
      setMode(block, checked ? checked.value : 'standard');
      block.querySelectorAll('select[data-jh-remember]').forEach(restore);
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.matches('[data-jh-mode]')) {
      var block = t.closest('[data-jh-size]');
      if (block) setMode(block, t.value);
      return;
    }
    if (t.matches('[data-jh-size] select[data-jh-remember]') && t.value) {
      save(t.getAttribute('data-jh-remember'), t.value);
    }
  });

  /* ---------- 2. Customisation charge ---------- */
  var chargeVariantId = null;
  var busy = false;
  var again = false;

  function getJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error(url + ' -> ' + r.status);
      return r.json();
    });
  }
  function post(path, body) {
    return getJSON(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function getChargeId() {
    if (chargeVariantId) return Promise.resolve(chargeVariantId);
    return getJSON(root + 'products/' + CHARGE_HANDLE + '.js').then(function (p) {
      chargeVariantId = p.variants[0].id;
      return chargeVariantId;
    });
  }
  function isCustomised(item) {
    var props = item.properties || {};
    return CUSTOM_KEYS.some(function (k) { return props[k] && String(props[k]).trim() !== ''; });
  }

  function syncCharge() {
    if (busy) { again = true; return; }
    busy = true;
    Promise.all([getChargeId(), getJSON(root + 'cart.js')])
      .then(function (res) {
        var id = res[0], cart = res[1], needed = 0, lines = [];
        cart.items.forEach(function (item) {
          if (item.variant_id === id) lines.push(item);
          else if (isCustomised(item)) needed += item.quantity;
        });
        var have = lines.reduce(function (n, l) { return n + l.quantity; }, 0);
        if (have === needed && lines.length <= 1) return false;

        var chain = Promise.resolve();
        if (lines.length) {
          lines.slice(1).forEach(function (l) {
            chain = chain.then(function () { return post('cart/change.js', { id: l.key, quantity: 0 }); });
          });
          chain = chain.then(function () { return post('cart/change.js', { id: lines[0].key, quantity: needed }); });
        } else {
          chain = chain.then(function () { return post('cart/add.js', { items: [{ id: id, quantity: needed }] }); });
        }
        return chain.then(function () { return true; });
      })
      .then(function (changed) {
        if (changed) document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function (err) { console.warn('[customisation charge]', err); })
      .then(function () {
        busy = false;
        if (again) { again = false; syncCharge(); }
      });
  }

  document.addEventListener('ajaxProduct:added', syncCharge);
  document.addEventListener('cart:updated', syncCharge);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { initBlocks(); syncCharge(); } });

  function start() { initBlocks(); syncCharge(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();